﻿export class request_password_reset {
    public user_name: string = "";
    public current_password: string = "";
    public new_password: string = "";
}